<template>
    <b-modal
            v-model="show"
            centered
            size="lg"
            :id="modalId"
            :title="`Detail Horoscope Annual`"
            @hidden="closeModal()"
    >
        <HoroscopeAnnualForm
                class="mb-3"
                :form-data="horoscopeAnnualData"
                :loading="loading"
                :horoscope-types="horoscopeTypes"
                :zodiac-signs="zodiacSigns"
                ref="HoroscopeAnnualForm"
                @saveHoroscopeAnnual="updateHoroscopeAnnual"
        />

        <div slot="modal-footer" class="w-100">
            <b-button
                    :disabled="loading || !btnText.valid"
                    :variant="`${!btnText.valid ? 'outline-danger': 'success'}`"
                    size="md"
                    class="float-left"
                    @click="checkValidValues()"
            >
                {{btnText.text}}
                <b-spinner v-if="loading" type="border" small/>
            </b-button>
        </div>
    </b-modal>
</template>

<script>
    import HoroscopeAnnualForm from '@/components/Horoscopes/HoroscopeAnnual/HoroscopeAnnualForm.vue';
    import Loader from '@/components/Includes/Loader/Loader.vue';
    import { HOROSCOPES_ANNUAL_CHANGE_HOROSCOPE } from '@/store/constants';

    export default {
        name: 'HoroscopeAnnualDetail',
        components: {
            Loader,
            HoroscopeAnnualForm
        },
        props: {
            modalId: {
                type: String,
                required: false,
            },
            modalTitle: {
                type: String,
                required: false,
            },
            hideFooter: {
                type: Boolean,
                required: false,
            },
            showModal: {
                type: Boolean,
                required: true,
            },
            horoscopeAnnualData: {
                type: Object,
                required: false,
            },
            zodiacSigns: {
                type: Array,
                required: true,
            },
            horoscopeTypes: {
                type: Array,
                required: true,
            },
        },
        data() {
            return {
                loading: true,
                show: null,

            }
        },
        computed: {
            btnText() {
                const valid = this.$validator.errors.items.length === 0;
                return {
                    text: valid ? 'Update' : 'Please enter the correct data',
                    valid
                };
            }
        },
        watch: {
            showModal(value) {
                this.show = this.showModal;
            }
        },
        methods: {
            closeModal() {
                this.loading = false;
                this.$emit('closeModalHoroscopeAnnual')
            },

            checkValidValues() {
                this.$refs.HoroscopeAnnualForm.handleSave()
            },

            async updateHoroscopeAnnual(horoscopeData) {
                try {
                    this.loading = true;

                    const status = await this.$store.dispatch(HOROSCOPES_ANNUAL_CHANGE_HOROSCOPE, horoscopeData);

                    if (status === 'changed') {
                        this.closeModal();

                        this.$emit('UpdateHoroscopeAnnual');

                        this.$notify({
                            group: 'notice',
                            title: `Horoscope`,
                            text: 'Updated Successfully',
                            type: 'success'
                        });
                        this.loading = false;
                    } else {
                        this.loading = false;
                    }
                } catch (error) {
                    throw new Error(error);
                }
            },
        },
        mounted() {
            this.loading = false;
        },
    }
</script>
